
import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import LoginFrom, {
  CodeForm,
  MobileLoginForm,
  EmailLoginForm
} from "@/lib/form/login/LoginFrom";
import { ElForm } from "element-ui/types/form";
import Info from "../lib/model/account/info";
import Url from "@/lib/common/url";
import Auth from "@/lib/common/auth";
import Reg from "@/lib/common/Reg";
import Config from "@/config/config";

class PasswordForm {
  username = "";
  password = "";
}

@Component({
  components: {
    Header: AuthHeader
  }
})
export default class AiLogin extends Vue {
  seconds = 0;
  interval = 0;
  codeForm: CodeForm = new CodeForm();
  loginFrom: LoginFrom = new LoginFrom();
  rules = this.loginFrom.rules();
  formElement!: ElForm;
  sendingCaptchaLock = false;
  loginLock = false;
  returnUrl = Url.query("returnUrl");
  loginType = "psw";
  pswLoginError = false;
  pswErrorText = "";
  passwordForm = new PasswordForm();
  mobileLoginForm = new MobileLoginForm();
  emailLoginForm = new EmailLoginForm();
  captchaLoginError = false;
  captchaErrorText = "";
  loginShow = false;
  isSelected = false;
  locationOrigin = "";

  get isChecked() {
    if (this.loginType === "psw") {
      return (
        this.passwordForm.username !== "" && this.passwordForm.password !== ""
      );
    } else {
      return (
        this.loginFrom.phone !== "" &&
        this.loginFrom.phone.length === 11 &&
        this.loginFrom.captcha !== "" &&
        this.loginFrom.captcha.length === 6
      );
    }
  }

  get hasMobile() {
    if (this.loginType === "psw") {
      return false;
    } else {
      return this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11;
    }
  }

  mounted() {
    this.formElement = this.$refs["form"] as ElForm;
    this.locationOrigin = Config.homePageHost;
  }

  created() {
    const params = this.$route.query;
    if (params["fromAdmin"] == "1")
      window.sessionStorage.setItem("fromAdmin", "1");
    document.title = "登录";
    // if (Auth.token && Auth.userId && Auth.companyId) {
    //   window.location.href = "/dash?companyId=" + Auth.companyId;
    // } else {
    //   Auth.logout();
    //   Auth.token = "";
    // }
    const getToken = Auth.token;
    if (getToken) {
      Auth.initUser(false)
        .then(() => {
          this.$router.push("/dash");
        })
        .catch(() => {
          this.loginShow = true;
        });
    } else {
      //生产
      if (process.env.NODE_ENV === "production") {
        // oem 登录走 hire360
        if (window.location.host.includes("hire360")) {
          window.location.href = "http://www.hire360.cn/login?type=2";
          return;
        }
        // !薪人薪事那边需要用ai.hina.com这个域名申请从他们系统发送短信，他们短信供应商不允许提供有二次跳转的域名，
        // !因此这里不做跳转
        //三端登录
        // window.location.href = Config.homePageHost + "/login";
      } else {
        //开发
        this.$router.push("/");
      }
      this.loginShow = true;
    }
  }

  goHome() {
    this.$router.push({
      path: "/",
      query: this.$route.query
    });
  }

  checkMobileNumber(e: Event) {
    this.loginFrom.phone = (e.target as HTMLInputElement).value.replace(
      /[^\d]/g,
      ""
    );
  }

  getCode() {
    if (this.loginType === "captcha") {
      if (this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11) {
        if (this.sendingCaptchaLock) {
          return;
        }
        if (this.seconds > 0) {
          return;
        }
        this.sendingCaptchaLock = true;
        // 获取验证码
        this.codeForm.phone = this.loginFrom.phone;
        Info.getCode(this.codeForm)
          .then(() => {
            this.seconds = 60;
            this.interval = setInterval(() => {
              this.seconds--;
              if (this.seconds <= 0) {
                clearInterval(this.interval);
                this.sendingCaptchaLock = false;
              }
            }, 1000);
          })
          .catch((err: any) => {
            this.captchaErrorText = err.message;
            this.captchaLoginError = true;
          })
          .finally(() => {
            this.sendingCaptchaLock = false;
          });
      }
    } else {
      return;
    }
  }

  login() {
    if (this.loginLock) {
      return;
    }
    if (!this.isChecked) return;
    if (this.loginLock) return;
    this.loginLock = true;

    if (this.loginType === "psw") {
      if (!this.isSelected) {
        this.pswErrorText = "请同意《海纳个人信息保护协议》";
        this.pswLoginError = true;
        this.loginLock = false;
        return;
      }
      this.pswLoginError = false;
      if (Reg.isMobile(this.passwordForm.username)) {
        this.mobileLoginForm.phone = this.passwordForm.username;
        this.mobileLoginForm.password = this.passwordForm.password;
        // sensors.track("click_login", {
        //   login_type: "password"
        // });
        return Info.mobileLogin(this.mobileLoginForm)
          .then(() => {
            window.location.href = "/dash";
          })
          .catch((err: any) => {
            this.pswErrorText = err.message;
            this.pswLoginError = true;
          })
          .finally(() => {
            this.loginLock = false;
          });
      } else {
        this.emailLoginForm.email = this.passwordForm.username;
        this.emailLoginForm.password = this.passwordForm.password;
        // sensors.track("click_login", {
        //   login_type: "password"
        // });
        return Info.emailLogin(this.emailLoginForm)
          .then(info => {
            window.location.href = "/dash";
          })
          .catch(() => {
            this.pswErrorText = "用户名或密码错误，请检查后重试";
            this.pswLoginError = false;
          })
          .finally(() => {
            this.loginLock = false;
          });
      }
    } else {
      this.captchaLoginError = false;
      if (!this.isSelected) {
        this.captchaErrorText = "请同意《海纳个人信息保护协议》";
        this.captchaLoginError = true;
        this.loginLock = false;
        return;
      }
      // sensors.track("click_login", {
      //   login_type: "captcha"
      // });
      this.loginLock = true;
      return Info.loginByMobileCaptcha(this.loginFrom)
        .then(() => {
          window.location.href = "/dash";
        })
        .catch((err: any) => {
          this.captchaErrorText = err.message;
          this.captchaLoginError = false;
        })
        .finally(() => {
          this.loginLock = false;
        });
    }
  }
}
